/*import React from "react";
import ReactDom from "react-dom";
import "./index.css";
//USING PROPS SETUP
//without using arrow function
const firstBook = {
  title: "A Promised Land",
  author: "Barack Obama",
  image:
    "https://images-na.ssl-images-amazon.com/images/I/41L5qgUW2fL._AC_SX184_.jpg"
};
const SecondBook = {
  title: "Home Body",
  author: "Rupi Kaur",
  image:
    "https://images-na.ssl-images-amazon.com/images/I/41XWaq6RhLL._AC_SX184_.jpg"
};
const ThirdBook = {
  title: "GreenLights",
  author: "Mathew McConaughey",
  image:
    "https://images-na.ssl-images-amazon.com/images/I/41U3yoF6sXL._AC_SX184_.jpg"
};

function BookList() {
  return (
    <section className="hello">
      <Book
        image={firstBook.image}
        title={firstBook.title}
        author={firstBook.author}
      />
      <Book
        image={SecondBook.image}
        title={SecondBook.title}
        author={SecondBook.author}
      />
      <Book
        image={ThirdBook.image}
        title={ThirdBook.title}
        author={ThirdBook.author}
      />
      
    </section>
  );
}
//Steps to create props
//>>>>>>>firstly inside whcih component you are going to use props define it
//>>>>>>>then for which the wariable being declared., accessed that particular variable using the . operator 
//this is the first way
const Book = props => {
  // const titleno = "I Will Save My Land";
  // const authorname = "Sagar Kolwankar";
  //this is called as props destructing
  const {image, title, author}=props;
  const clickHandler=()=>{
    alert("hello world");
  }

  return (
    //it can return div element, section or ARTICLE ELEMENT
    //steps for creating event in react consists of the two parts(attribute,eventhandler )
    <article>
      {/* <img src="https://images-eu.ssl-images-amazon.com/images/I/61fyUYatiEL._AC_SX184_.jpg" /> */
     /* <img src={image} alt="no image"></img>
      <h2>{title}</h2>
      <h4>{author}</h4>
      <button type="button" onClick={clickHandler}></button>"
    </article>
  );
};

ReactDom.render(<BookList />, document.getElementById("root"));
// with arrow function
// const Greeting = () => {
//   return React.createElement(
//     "div",
//     {},
//     React.createElement("h1", {}, "Hello This Is My First Component")
//   );
// };
//explicit return(Creating simple fragments )
// const Shubham = () => <input type="checkbox" name="" id="" />;
// const Kokane = () => (
//   <div>
//     <h1>Welcome to the world of react</h1>
//     <h5>Toh Kiase hai AAp log</h5>
//   </div>
// );
//implicit return using return statement
// const Fubbi = () => {
//   return <h3>This is Implicit Return</h3>;
// };
// function BookList() {
//   return (
//     <div className="H1">
//       <h1>Hello This Is My First Component</h1>
//       <h3>Lets Get Started</h3>
//       <img src="" alt="" />
//       <input type="button" value="" />
//       <input type="text" name="" id="" />
//       {/* <#--nested fragment--#> */
//       <Shubham />
//       <Kokane />
//       <Fubbi />
//     </div>
//   );
// }*/}

import React from 'react';
import ReactDom from 'react-dom';

// CSS
import './index.css';

import {data} from './books'
import SpecificBook from './Book'
import {greeting} from './testing/testing.js'

function BookList() {
  console.log(greeting);
  return (
    <section className='booklist'>
      {data.map((book, index) => {
        return <SpecificBook key={book.id} {...book}></SpecificBook>;
      })}
    </section>
  );
}



ReactDom.render(<BookList />, document.getElementById('root'));

